import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    input: {
      '&::placeholder': {
        color: colors.textTertiary,
      },
    },
    noOptions: {
      color: colors.textTertiary,
      padding: [spacing.sp03, spacing.sp04],
    },
  },
  {
    name: 'Combobox',
  },
);
